import {
  ConfigWrapper,
  DesktopFooter,
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
} from '@kanda-libs/ks-design-library';

interface UnsubLayoutDesktopProps {
  children: React.ReactNode;
}

const UnsubLayoutDesktop: React.FunctionComponent<UnsubLayoutDesktopProps> =
  function ({ children }) {
    return (
      <ConfigWrapper desktopFooter={DesktopFooter} desktopHeader={undefined}>
        <DesktopLayoutBoxed>
          <DesktopLayoutBoxedContent>
            <div>{children}</div>
          </DesktopLayoutBoxedContent>
        </DesktopLayoutBoxed>
      </ConfigWrapper>
    );
  };

export default UnsubLayoutDesktop;
